import { render, staticRenderFns } from "./LocsPersonalMainContainer.vue?vue&type=template&id=3adb7ce8&scoped=true"
import script from "./LocsPersonalMainContainer.vue?vue&type=script&lang=js"
export * from "./LocsPersonalMainContainer.vue?vue&type=script&lang=js"
import style0 from "./LocsPersonalMainContainer.vue?vue&type=style&index=0&id=3adb7ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adb7ce8",
  null
  
)

export default component.exports